import util from '@bmp-vue/core/api/util'

const controller = 'Rrc0019';
export default Object.assign({}, util.GetCrud(controller, ['']), {
    ValidarRegistro: function(dto) {
        return util.Axios.Post(
            controller + "/Validar",
            dto
        );
    },
    Incluir: function (dto) {
        return util.Axios.Post(
            controller + '/operacao',
            dto
        );
    },
    IncluirRegistrosEmLote: function (dto, identEmissorPrincipal, identEmissorAdm) {
        const url = `${process.env.VUE_APP_ROOT_API}${controller}/operacao/ImportarLote`;
        const config = {
            headers: {
                'identEmissorPrincipal': identEmissorPrincipal,
                'identEmissorAdm': identEmissorAdm
            }
        };

        return  util.Axios.Dynamic('post', url, dto, config);
    },
    AlterarRegistroEmLote: function (dto, identEmissorPrincipal, identEmissorAdm) {
        const url = `${process.env.VUE_APP_ROOT_API}${controller}/operacao/ImportarLote/Alteracao`;
        const config = {
            headers: {
                'identEmissorPrincipal': identEmissorPrincipal,
                'identEmissorAdm': identEmissorAdm
            }
        };

        return  util.Axios.Dynamic('post', url, dto, config);
    },
    GetAllTitularesByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/titulares`)
    },
    GetAllConjuntosDomiciliosByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/ConjuntosDomicilios`)
    },
    GetAllRenegociacoesDividasByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RenegociacoesDividas`)
    },
    GetAllCessionariosAutorizadosByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/CessionariosAutorizados`)
    },
    GetRespostaSincronaByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RespostaSincrona`)
    },
    GetRespostaRegistroByCodigo: function(codigo) {
        return util.Axios.GetAll(controller + `/${codigo}/RespostaRegistro`)
    }
});  